import { MergeSchemaData } from '../model/merge.schema.data';

export function getMergeSourceEntity(data: MergeSchemaData | MergeSchemaData[]) {
    return Array.isArray(data)
        ? data[0]?.entity
        : data?.entity;
}